import { ContentEntity } from "../common/content-entity";

export declare class BooleanAnswer {
  public content: ContentEntity;
  public id: number;
  public order: number;
  public savedItem: boolean;
}